<template>
  <div
    :style="{ backgroundColor: storeLocation == 0 ? 'black' : 'white' }"
    class="py-4 container-fluid"
  >
    <div v-if="storeLocation != 0" class="row">
      <div
        class="col-sm-12 d-flex justify-content-between align-items-center mb-3"
      >
        <h2><u>Out of Stock Items</u></h2>
        <!-- <h4 v-if="store_list.length" class="fw-bold">
          {{
            store_list.find((s) => s.id == storeLocation)
              ? store_list.find((s) => s.id == storeLocation).store_name
              : "Selected Store"
          }}
        </h4> -->

        <div class="d-flex align-items-center">
          <!-- <select
            @change="changeStore"
            name="store_id"
            class="form-select form-select-sm me-2"
            style="width: auto; min-width: 200px"
          >
            <option value="0">Select Store...</option>
            <option
              v-for="store in store_list"
              :key="store.id"
              :value="store.id"
              :selected="store.id == storeLocation"
            >
              {{ store.store_name }}
            </option>
          </select> -->

          <h4 v-if="store_list.length" class="fw-bold">
            {{
              store_list.find((s) => s.id == storeLocation)
                ? store_list.find((s) => s.id == storeLocation).store_name
                : "Selected Store"
            }}
          </h4>
        </div>
      </div>

      <div class="col-sm-12">
        <div class="card mb-4">
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <nav>
                <Search
                  :placeholder="placeHolderText"
                  @onsearch="handleSearch"
                />
              </nav>
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th>#s/n</th>
                    <th>Item Name</th>
                    <th>Class & Category</th>
                    <th>Available qty</th>
                    <th>Reorder Level</th>
                  </tr>
                </thead>

                <tbody v-if="users.length">
                  <tr v-for="user in users" :key="user.id">
                    <td>#{{ user.id }}</td>
                    <td>
                      <h6 class="mb-0 text-sm">
                        <itemname
                          :ItemName="user.item_name"
                          :ItemBrand="user.brand_name"
                          :ItemStrength="user.item_strength"
                        />
                      </h6>
                      <p class="text-xs text-secondary mb-0">
                        {{ user.class_name }} - {{ user.category_name }}
                      </p>
                    </td>
                    <td>
                      <h6 class="mb-0 text-sm">{{ user.class_name }}</h6>
                      <p class="text-xs text-secondary mb-0">
                        {{ user.category_name }}
                      </p>
                    </td>
                    <td style="color: red">{{ user.c_quantity }}</td>
                    <td style="color: black; background-color: beige">
                      {{ user.reorder_level }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <div v-if="!users.length && !apiLoading">
                <p class="text-center mt-3">No Records found.</p>
              </div>

              <div v-if="apiLoading" class="text-center py-3">Loading...</div>

              <pagination
                v-if="!apiLoading"
                :all-data="allData"
                @content-change="handleContentChange"
                @loader-set="loaderSet"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-else
      :style="{
        height: '60vh',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
      }"
      class="d-flex"
    >
      <form class="d-flex align-items-start">
        <div class="d-flex flex-column align-items-center me-2">
          <label class="mb-2 text-white fw-bold" style="font-size: 1.5em">
            Select Store To Continue...
          </label>
          <div class="d-flex">
            <select
              style="min-width: 20em"
              @change="changeStore"
              name="store_id"
              class="form-control me-2"
            >
              <option value="0">Select Store...</option>
              <option
                v-for="store in store_list"
                :key="store.id"
                :value="store.id"
                :selected="store.id == storeLocation"
              >
                {{ store.store_name }}
              </option>
            </select>
          </div>
        </div>
      </form>
    </div>

    <CreateStockModal
      @close="handleCloseModalAddStock"
      v-if="showAddStockModal"
    />
    <StockUploadModal />
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
import Pagination from "../components/pagination.vue";
import Search from "../components/search.vue";
import Itemname from "./components/ItemName.vue";
import CreateStockModal from "./modals/add_stock_manuallyModal.vue";
import StockUploadModal from "./modals/stockUpload.vue";

export default {
  name: "OutOfStock",
  components: {
    Pagination,
    Search,
    Itemname,
    CreateStockModal,
    StockUploadModal,
  },
  data() {
    return {
      showAddStockModal: false,
      users: [],
      allData: {},
      apiLoading: true,
      tableLoading: true,
      placeHolderText: "Search Item...",
      store_list: [],
    };
  },

  computed: {
    // This computed property ensures `storeLocation` always reflects the current URL
    storeLocation() {
      return this.$route.params.storeLocation;
    },
  },

  watch: {
    // This watcher is the key to fixing the problem. It listens for changes to the URL's store ID.
    storeLocation: {
      handler(newStoreLocation) {
        if (newStoreLocation && newStoreLocation != 0) {
          this.callApi();
        } else {
          // Clear the data if no store is selected
          this.users = [];
          this.allData = {};
        }
      },
      // `immediate: true` runs the watcher on initial component mount, eliminating the need for a separate call in `mounted()`.
      immediate: true,
    },
  },

  methods: {
    async handleSearch(searchTerm) {
      this.apiLoading = true;
      try {
        const url = `inventory/search_stock_overview_out_of_stock/${this.storeLocation}`;
        const body = { search_param: searchTerm };
        const rs = await generalApiRequest(url, "GET", body, 1);
        this.allData = rs.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.apiLoading = false;
      }
    },

    links(url) {
      this.$router.push(url);
    },

    handleContentChange(contents) {
      this.users = contents;
    },

    loaderSet(value) {
      this.tableLoading = value;
    },

    // This method now only updates the route, which triggers the watcher.
    changeStore(e) {
      const selectedStore = e.target.value;
      this.$router.push("/item_stock/" + selectedStore);
    },

    async get_stores_list() {
      try {
        const url = "inventory/getCompanyItemStores_for_input";
        const store_list = await generalApiRequest(url, "GET", {}, 1);
        this.store_list = store_list.data;
      } catch (error) {
        console.error("Error fetching store list:", error);
      }
    },

    handleCloseModalAddStock() {
      this.showAddStockModal = false;
    },

    handleOpenModalAddStock() {
      this.showAddStockModal = true;
    },

    // A single, reusable method to fetch the stock overview data
    async callApi() {
      this.apiLoading = true;
      try {
        const url = `inventory/get_stock_overview_out_of_stock/${this.storeLocation}`;
        const data = await generalApiRequest(url, "GET", {}, 1);
        this.allData = data.data;
      } catch (error) {
        console.error("Error fetching stock overview:", error);
      } finally {
        this.apiLoading = false;
      }
    },
  },

  mounted() {
    // Only fetching the store list is necessary on mount now.
    this.get_stores_list();
  },
};
</script>

<style scoped>
.centered {
  margin-top: 2em;
}
.compact-btn {
  padding: 8px 6px !important;
  line-height: 1.2;
  border-radius: 4px;
  margin: 2px;
}
</style>
